/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { pd } from '@airasia-rn/ui';

export const TILE_WIDTH = 70;
export const TILE_GAP = 16;
const CONTAINER_PADDING = pd.ref.space.spacing40.px;

export interface TileVisibility {
  visibleTileCount: number;
  hasMore: boolean;
}

export function calculateVisibleTiles(
  containerWidth: number,
  totalTiles: number,
): TileVisibility {
  const contentWidth = containerWidth - 2 * CONTAINER_PADDING;

  if (contentWidth <= 0) return { visibleTileCount: 0, hasMore: false };

  const fit = Math.floor((contentWidth + TILE_GAP) / (TILE_WIDTH + TILE_GAP));

  if (fit >= totalTiles)
    return { visibleTileCount: totalTiles, hasMore: false };

  return {
    visibleTileCount: Math.min(totalTiles - 1, fit - 1),
    hasMore: true,
  };
}
